import { isPermalinkPath } from '@/features/seo-listing/consts';

/**
 * Whether a redirect *onto* `toUrl` is safe given resolve(toUrl) outcome.
 *
 * Disabled SEO: resolve(permalink) is 404 while /seo/redirect may still map
 * GET → permalink; following that without resolve ok causes GET ↔ permalink
 * loops (seen on tags). Pair with shouldFollowSeoRedirectTarget(fromPath) so
 * live permalinks are also not bounced back to GET.
 */
export const canFollowSeoRedirectToUrl = (
  toUrl: string,
  permalinkResolveSucceeded: boolean,
): boolean => {
  const toPath = toUrl.split('?')[0] ?? '';
  if (!isPermalinkPath(toPath)) return true;
  return permalinkResolveSucceeded;
};
